import { useState } from "react";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useKeycloak } from "@react-keycloak/web";
import { useStore } from "react-redux";
import { ReactComponent as UserLogo } from "assets/icons/base/user-logo.svg";
import { useIntl } from "react-intl";

const PreferencesProfile = () => {
    const [isBoxOpen, setIsBoxOpen] = useState(false);

    const intl = useIntl();

    const store = useStore();

    const { keycloak }: any = useKeycloak();

    const logOut = () => {
        keycloak.logout();
    };

    const generateOptionBoxClass = () => {
        if (isBoxOpen) {
            return "c-goaigua-preferences-profile";
        } else {
            return "c-goaigua-preferences-profile --hidden-profile";
        }
    };

    return (
        <>
            {isBoxOpen && (
                <div
                    className="c-goaigua-preferences-menu__dropdown-background"
                    onClick={() => setIsBoxOpen(false)}
                ></div>
            )}
            <div className={generateOptionBoxClass()} tabIndex={0}>
                <div className="c-user-menu__image">
                    <UserLogo />
                </div>

                <div
                    className="c-user-menu"
                    onClick={() => setIsBoxOpen(!isBoxOpen)}
                >
                    <div className="c-user-menu__name">
                        {store.getState().keycloak.userName}
                    </div>
                    <div className="c-user-menu__caret">
                        <FontAwesomeIcon icon={faAngleDown} />
                    </div>
                </div>
                <div
                    className="c-goaigua-preferences-profile__dropdown-box"
                    // {...boxEventHandlers}
                    tabIndex={0}
                >
                    <div className="c-user-menu__logout" onClick={logOut}>
                        {intl.formatMessage({
                            id: "app.components.profile.logout",
                        })}{" "}
                    </div>
                </div>
                <div
                    className="c-goaigua-preferences-profile__dropdown-triangle"
                    // {...boxEventHandlers}
                    tabIndex={0}
                ></div>
            </div>
        </>
    );
};

export default PreferencesProfile;
